import React from 'react';

import {ScoresListHeaderModuleProps} from "../../models/scores-list-header-module.props";
import {ScoresListHeaderModuleMobileDateViewModel} from "../../models/scores-list-header-module.mobile-date.view-model";
import {ButtonComponentProps} from "../../../../core/components/misc/buttons/button";
import {LinkButton} from "../../../../core/components/misc/buttons/link-button";
import {IOC} from "../../../../infrastructure/ioc";
import {IntersectionObserver} from "../../../../core/components/intersection-observer/intersection-observer";

export class ScoresListWidgetHeaderMobileDaterButtonComponentProps extends ScoresListHeaderModuleProps {
  ioc: IOC;
  mobileDate: ScoresListHeaderModuleMobileDateViewModel;
  isActive: Boolean;
  width: Number;
}

export const ScoresListHeaderModuleMobileDaterButton = ({controller, mobileDate, width, isActive, onDateChange}: ScoresListWidgetHeaderMobileDaterButtonComponentProps) => {
  const {state} = controller

  const buttonProps: ButtonComponentProps = {
    onClick: () => {
      state.startDate = mobileDate.date;

      if (onDateChange) {
        onDateChange(mobileDate.date);
      }

      return true
    },
    linkModel: onDateChange ? null : mobileDate.linkModel,
    style: {
      width: width || 40
    }
  };

  return (
    <LinkButton {...buttonProps}>
      <IntersectionObserver className={['scores-list-header-module-mobile-dater-button', isActive ? 'scores-list-header-module-mobile-dater-active-button' : ''].join(' ')}>
        <div className={'scores-list-header-module-mobile-dater-button-name'}>
          {
            mobileDate.name.toUpperCase()
          }
        </div>
        <div className={'scores-list-header-module-mobile-dater-button-day'}>
          {
            mobileDate.day
          }
        </div>
      </IntersectionObserver>
    </LinkButton>
  );
};
